<div class="search-box-container">
  <i class="bi bi-search" [class]="lang.isRTL ? 'rtl--search' : ''" (click)="onEnter()"></i>
  <input type="text" [ngModel]="key" (search)="onEnter()" (ngModelChange)="onKeyChange($event)" (keyup.enter)="onEnter()"
    class="form-control form-control-lg input--search" [class]="lang.isRTL ? 'rtl--input' : ''" [placeholder]="placeholder" />
  <i *ngIf="key" class="bi bi-x" [class]="lang.isRTL ? 'rtl--x' : ''" (click)="clearSearch()" [title]="'common.clear' | translate "></i>
</div>
